export { default } from './ProductLookup.container';
